import { Box, Button, Image } from "grommet";
import { Download } from "grommet-icons";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";

export default function QRCodeBanner({ donatePageLink }) {

    const { t, ready } = useTranslation('settings', {
        useSuspense: false,
    });

    const bannerRef = useRef(null);
    const qrRef = useRef(null);

    const downloadBanner = async () => {

		if (!bannerRef.current || !qrRef.current) return;

		const banner = bannerRef.current.querySelector("img");
        const qrSvg = qrRef.current.querySelector("svg");
        
        if (!qrSvg) return;

        console.log('download 3');
        // Create canvas
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = 1080//bannerRect.width;
        canvas.height = 1350//bannerRect.height;

        const canvasWidth = 1080//canvas.width;
        const canvasHeight = 1350//canvas.height;
        const imgWidth = 680//svgSize.width;
        const imgHeight = 680//svgSize.height;

        const x = (canvasWidth / 2) - (imgWidth / 2);
        const y = (canvasHeight / 2) - (imgHeight * 0.76);

        const response = await fetch(banner.src);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        
        await drawImgToCanvas(canvas, ctx, url, canvasHeight, canvasWidth,  0, 0)

        await drawSvgToCanvas(canvas, ctx, qrSvg, imgHeight, imgWidth,  x, y);

        downloadCanvas(canvas);
	};

    function drawImgToCanvas(canvas, ctx, imgUrl, heigh, width, x, y) {
        return new Promise((resolve, reject) => {
            
            const img = document.createElement("img");
            img.height = heigh;
            img.width = width;
            img.onload = function() {
                drawImageToCanvas(canvas, ctx, img, x, y);
                // URL.revokeObjectURL(imgUrl); // Clean up
                resolve();
            };
            img.onerror = function() {
                alert('Failed to load SVG. Please check your SVG code.');
                // URL.revokeObjectURL(imgUrl);
                reject();
            };
            img.src = imgUrl;
        })
    }

    function drawSvgToCanvas(canvas, ctx, svg, heigh, width, x, y) {
        return new Promise((resolve, reject) => {
            const svgData = new XMLSerializer().serializeToString(svg);
            const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
            const svgUrl = URL.createObjectURL(svgBlob);
            
            const img = document.createElement("img");
            img.height = heigh;
            img.width = width;
            img.onload = function() {
                drawImageToCanvas(canvas, ctx, img, x, y);
                URL.revokeObjectURL(svgUrl); // Clean up
                resolve();
            };
            img.onerror = function() {
                URL.revokeObjectURL(svgUrl);
                reject();
            };
            img.src = svgUrl;
        })
    }

    function drawImageToCanvas(canvas, ctx, img, x, y) {
        // Clear canvas
        // ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        ctx.drawImage(img, x, y, img.width, img.height);
    }

    const downloadCanvas = async (canvas) => {
        // Convert canvas to blob
        canvas.toBlob(async (blob) => {
            // const response = await fetch(imgElement.src);
            // const blob = await response.blob();
            // const url = window.URL.createObjectURL(blob);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = 'qr-code-banner.png';
            link.href = url;
            link.click();
            
            // Clean up
            URL.revokeObjectURL(url);
        }, 'image/png');
    }

    if (ready) {
        return (
            <Box gap="small" width={'270px'}>
                <Box ref={bannerRef} style={{ position: "relative" }} height="337.5px" width="270px">
                    <Image
                        src={`${process.env.REACT_APP_CDN_BASE_URL}/donate-options/qr_code_banner.webp`}
                        fit="contain"
                        height="100%"
                        width="100%"
                    />
                    {donatePageLink && (
                        <Box
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "37%",
                                transform: "translate(-29.5%, -76%)",
                            }}
                        >
                            <Box
                                ref={qrRef}
                                style={{
                                    height: "auto",
                                    margin: "0 auto",
                                    maxWidth: 170,
                                    width: "100%",
                                }}
                            >
                                <QRCode
                                    size={256}
                                    style={{
                                        height: "auto",
                                        maxWidth: "100%",
                                        width: "100%",
                                    }}
                                    value={donatePageLink}
                                    viewBox={`0 0 256 256`}
                                />
                            </Box>
                        </Box>
                    )}
                </Box>
                <Button label={t('downloadBtn')} icon={<Download />} onClick={downloadBanner} />
            </Box>
        );
    }
}
